// removed by extract-text-webpack-plugin
module.exports = {"continue-button":"continue-button__1RtsS","invalid":"invalid__gcEQu","back-button":"back-button__2_vSB","finish-button":"finish-button__1ceEA","arrow":"arrow__J-RhI"};


//////////////////
// WEBPACK FOOTER
// ./components/form/styles/Buttons.scss
// module id = aBKB
// module chunks = 1